<template>
  <div class="initial-consultation">
    <!-- 诊前沟通 -->
    <template v-if="info.preConsults && info.preConsults.length > 0">
      <div
        v-for="section in info.preConsults"
        :key="section.key"
        class="consultation-section"
      >
        <div class="section-header row flex-center">
          <div class="section-title">诊前沟通</div>
          <div class="flex-1 section-registrant">
            <span class="section-label">登记人：</span>
            <span>{{ section.executorName }}</span>
          </div>
          <div
            v-if="canEditSection(section)"
            class="edit-btn"
            @click="preConsultsEdit(section)"
          >
            修改
          </div>
        </div>
        <div class="section-content">
          {{ section.returnVisitContent }}
        </div>
      </div>
    </template>

    <!-- 就诊情况 -->
    <template v-if="info.patientConsult && info.patientConsult.length > 0">
      <div
        v-for="section in info.patientConsult"
        :key="section.key"
        class="consultation-section"
      >
        <div class="section-header row flex-center">
          <div class="section-title">就诊情况</div>
          <div class="flex-1 section-registrant">
            <span class="section-label">登记人：</span>
            <span>{{ section.executorName }}</span>
          </div>
        </div>
        <div class="section-content">
          {{ section.returnVisitContent }}
        </div>
      </div>
    </template>

    <!-- 当天回访 -->
    <template v-if="info.returnVisits && info.returnVisits.length > 0">
      <div
        v-for="section in info.returnVisits"
        :key="section.key"
        class="consultation-section"
      >
        <div class="section-header row flex-center">
          <div class="section-title">当天回访</div>
          <div class="flex-1 section-registrant">
            <span class="section-label">登记人：</span>
            <span>{{ section.executorName }}</span>
          </div>
          <div
            v-if="canEditSection(section)"
            class="edit-btn"
            @click="returnVisitsEdit(section)"
          >
            修改
          </div>
        </div>
        <div class="section-content">
          {{ section.returnVisitContent }}
        </div>
      </div>
    </template>

    <!-- 无信息提示 -->
    <div v-if="showEmptyState" class="consultation-section">
      <div class="empty-text">暂无初诊信息</div>
    </div>
  </div>
</template>

<script>
import { todayTodoStore } from "@/store/h5/todayTodo.js";
import { userStore } from "@/store/user.js";

export default {
  name: "InitialConsultation",
  props: {
    info: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    showEmptyState() {
      const preConsults = this.info.preConsults || [];
      const patientConsult = this.info.patientConsult || [];
      const returnVisits = this.info.returnVisits || [];

      return (
        preConsults.length === 0 &&
        patientConsult.length === 0 &&
        returnVisits.length === 0
      );
    },
  },
  methods: {
    //2026-03-26 登记人为当前员工才能修改
    canEditSection(section) {
      const user = userStore();
      const currentEmployeeId = user?.userInfo?.detail?.employee_id;
      const sectionExecutorId = section?.executorId;

      // 通过 ID 判断是否为当前员工
      if (currentEmployeeId && sectionExecutorId) {
        return String(sectionExecutorId) === String(currentEmployeeId);
      }

      return false;
    },
    //诊前沟通修改
    preConsultsEdit(section) {
      if (!this.canEditSection(section)) {
        return;
      }
      const todayTodoStoreInstance = todayTodoStore();
      //兼容已经写好的编辑方法
      section.returnVisitId = section.id;
      todayTodoStoreInstance.setCurrentPreDiagnosis(section);
      this.$router.push("/todayTodo/regCommStatus?type=tomorrow&status=2");
    },
    // 当天回访修改
    returnVisitsEdit(section) {
      if (!this.canEditSection(section)) {
        return;
      }
      // 将当前的self内容添加到当前回访对象中
      const todayTodoStoreInstance = todayTodoStore();
      //兼容已经写好的编辑方法
      section.returnVisitId = section.id;
      todayTodoStoreInstance.setCurrentVisit(section);
      this.$router.push(
        "/todayTodo/regCommStatus?type=todayVisitFollowUp&status=2",
      );
    },
  },
};
</script>

<style scoped lang="scss">
.initial-consultation {
  overflow: hidden;

  .consultation-section {
    padding: 0.208rem 0.25rem;
    background-color: #fff;
    border-radius: 0.208rem;
    margin-bottom: 0.208rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section-header {
    align-items: center;
    margin-bottom: 0.125rem;
    font-size: 0.25rem;
    color: #666;
  }

  .section-title {
    color: #333;
    font-weight: 600;
    margin-right: 0.25rem;
    flex-shrink: 0;
  }

  .section-registrant {
    min-width: 0;
    word-break: break-all;
  }

  .section-label {
    color: #666;
  }

  .edit-btn {
    width: 1rem;
    padding: 0.042rem 0.208rem;
    border: 1px solid #d9d9d9;
    border-radius: 0.104rem;
    color: #666;
    background-color: #fff;
    text-align: center;
    line-height: 1.5;
    flex-shrink: 0;
  }

  .section-content {
    font-size: 0.25rem;
    line-height: 1.6;
    color: #333;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .empty-text {
    padding: 0.333rem 0.25rem;
    font-size: 0.25rem;
    color: #999;
    text-align: center;
  }
}
</style>
